{
  "addSupplier": {
    "stepper": {
      "title": "Aggiungi fornitore",
      "steps": {
        "generalInfo": {
          "title": "Info generali",
          "description": "Inserisci le informazioni generali del fornitore"
        },
        "riskAssessment": {
          "title": "Valutazione del rischio",
          "description": "Seleziona il livello di rischio del fornitore"
        },
        "supportingDocuments": {
          "title": "Documenti di supporto",
          "description": "Carica o collega la documentazione richiesta"
        },
        "approval": {
          "title": "Approvazione",
          "description": "Controlla tutte le informazioni e invia il fornitore per l'approvazione"
        }
      },
      "buttons": {
        "saveAsDraft": "Salva come bozza ed esci",
        "cancel": "Annulla",
        "previous": "Precedente",
        "next": "Avanti",
        "sendForApproval": "Invia per approvazione"
      }
    },
    "generalInfo": {
      "heading": "Info generali",
      "fields": {
        "supplierName": {
          "label": "Nome fornitore*",
          "helper": "Questo campo è obbligatorio per l'invio in approvazione."
        },
        "supplierType": {
          "label": "Tipo di fornitore",
          "helper": "Questo campo è obbligatorio per l'invio in approvazione."
        },
        "website": {
          "label": "Sito web"
        },
        "intendedUse": {
          "label": "Uso previsto"
        },
        "sponsor": {
          "label": "Sponsor",
          "helper": "Questo campo è obbligatorio per l'invio in approvazione."
        }
      },
      "contactInfo": {
        "heading": "Informazioni di contatto del fornitore",
        "fields": {
          "name": "Nome",
          "email": "Email",
          "phone": "Telefono",
          "address": "Indirizzo",
          "notes": "Note"
        }
      },
      "warnings": {
        "invalidFields": "Alcuni campi sembrano contenere valori non validi."
      }
    },
    "riskAssessment": {
      "heading": "Valutazione del rischio",
      "description": "I livelli di rischio sono definiti dalla politica dei fornitori. Se non sei sicuro ora, puoi tornare su questo punto più tardi. Nota che il livello di rischio è necessario per assegnare i documenti di supporto corretti come richiesto dalla politica."
    },
    "supportingDocuments": {
      "heading": "Documenti di supporto",
      "alerts": {
        "selectTypeAndRisk": "Seleziona il tipo di fornitore e il livello di rischio per vedere quali documenti sono richiesti.",
        "noMandatoryDocuments": "La tua politica dei fornitori non richiede documenti obbligatori per il tipo di fornitore {{type}} e il livello di rischio {{level}}.",
        "documentsMovedTitle": "Documenti spostati in \"Documenti aggiuntivi\"",
        "documentsMovedDescription": "Ogni livello di rischio può richiedere documenti diversi. Poiché il livello di rischio è stato modificato, tutti i documenti sono stati spostati in \"Documenti aggiuntivi\". Per riutilizzarli, scaricali e aggiungili ai documenti richiesti. Queste modifiche diventeranno effettive al salvataggio del fornitore."
      },
      "policyText": "La tua politica dei fornitori richiede i seguenti documenti per il tipo di fornitore {{type}} e il livello di rischio {{level}}.",
      "additionalDocumentsInfo": "Includi qualsiasi documentazione aggiuntiva pertinente per questo fornitore."
    },
    "approval": {
      "heading": "Approvazione",
      "infoText": "Rivedi le informazioni del fornitore prima di inviarle per l'approvazione.",
      "sections": {
        "generalInformation": "Informazioni generali",
        "supplierContactInformation": "Informazioni di contatto del fornitore",
        "riskLevel": "Livello di rischio",
        "supportingDocuments": "Documenti di supporto",
        "additionalDocuments": "Documenti aggiuntivi",
        "requiredAudits": "Audit richiesti",
        "approval": "Approvazione"
      },
      "fields": {
        "supplierName": "Nome fornitore",
        "supplierType": "Tipo di fornitore",
        "website": "Sito web",
        "intendedUse": "Uso previsto",
        "sponsor": "Sponsor",
        "name": "Nome",
        "email": "Email",
        "phone": "Telefono",
        "address": "Indirizzo",
        "notes": "Note",
        "approvers": "Approvatori"
      },
      "messages": {
        "noMandatoryDocuments": "Non ci sono documenti obbligatori",
        "noAdditionalDocuments": "Non ci sono documenti aggiuntivi",
        "requiredAuditsPolicy": "Per il tipo di fornitore {{type}} e il livello di rischio {{level}}, la tua politica dei fornitori richiede questi audit",
        "noRequiredAuditsPolicy": "Per il tipo di fornitore {{type}} e il livello di rischio {{level}}, la tua politica dei fornitori non richiede audit obbligatori",
        "auditFrequency": "Ogni {{count}} mese/i",
        "auditOnce": "Una sola volta",
        "approvalInfo": "Seleziona le persone che possono approvare questo fornitore. Deve essere selezionato almeno un utente Quality. Possono essere selezionati come approvatori solo gli utenti con accesso ai fornitori. L'approvazione sarà concessa quando tutti avranno accettato.",
        "auditReviewWarning": "Se è necessaria una revisione degli audit prima dell'approvazione, puoi salvare questo fornitore e aggiungere l'audit e tutti i suoi documenti nella sezione \"Audit\" di questo fornitore."
      },
      "warnings": {
        "requiredFieldsMissing": "Sembrano mancare alcuni campi obbligatori o alcuni campi presentano valori non validi"
      },
      "supplierPolicyLink": "politica dei fornitori"
    },
    "modals": {
      "discardChanges": {
        "title": "Scarta modifiche",
        "message": "Sei sicuro di voler scartare le modifiche a questo fornitore? Puoi anche salvarlo come bozza e finire più tardi.",
        "buttons": {
          "cancel": "Annulla",
          "saveAsDraft": "Salva come bozza",
          "discardChanges": "Scarta modifiche"
        }
      },
      "cantSaveSupplier": {
        "title": "Impossibile salvare il fornitore",
        "message": "Per salvare questo fornitore devi assegnargli un nome.",
        "button": "Ricevuto"
      },
      "changeSupplierType": {
        "title": "Cambiare tipo di fornitore?",
        "message": "Ogni livello di rischio può richiedere documenti diversi. Tutti i documenti saranno spostati in \"Documenti aggiuntivi\" quando salverai il fornitore.",
        "buttons": {
          "cancel": "Annulla",
          "change": "Cambia tipo di fornitore"
        }
      },
      "changeRiskLevel": {
        "title": "Cambiare livello di rischio?",
        "message": "Ogni livello di rischio può richiedere documenti diversi. Tutti i documenti saranno spostati in \"Documenti aggiuntivi\" quando salverai il fornitore.",
        "buttons": {
          "cancel": "Annulla",
          "change": "Cambia livello di rischio"
        }
      }
    },
    "validation": {
      "errors": {
        "supplierNameRequired": "Inserisci un nome per il fornitore",
        "supplierNameEmpty": "Il nome del fornitore non può essere vuoto",
        "supplierNameTooLong": "Il nome del fornitore non può superare i 350 caratteri",
        "supplierTypeRequired": "Seleziona un tipo di fornitore",
        "intendedUseTooLong": "Il campo Uso previsto non può superare i 4000 caratteri",
        "sponsorRequired": "Seleziona uno Sponsor",
        "contactNotesTooLong": "Il campo Note di contatto non può superare i 4500 caratteri",
        "riskTypeRequired": "Seleziona un tipo di rischio",
        "documentsRequired": "È richiesto almeno 1 documento di supporto per: {{documentNames}}",
        "approversRequired": "È necessario selezionare gli approvatori",
        "qualityUserRequired": "Gli approvatori devono contenere almeno un utente Quality"
      },
      "fieldNames": {
        "name": "Nome",
        "approvers": "Approvatori",
        "contactAddress": "Indirizzo di contatto",
        "contactEmail": "Email di contatto",
        "contactName": "Nome di contatto",
        "contactNotes": "Note di contatto",
        "contactPhone": "Telefono di contatto",
        "documents": "Documenti",
        "intendedUse": "Uso previsto",
        "riskType": "Tipo di rischio",
        "sponsor": "Sponsor",
        "supplierType": "Tipo di fornitore",
        "website": "Sito web"
      }
    }
  },
  "supplierList": {
    "heading": "Fornitori",
    "buttons": {
      "addSupplier": "Aggiungi fornitore",
      "import": "Importa",
      "exportAsl": "Esporta ASL",
      "exportCurrentView": "Esporta vista corrente in CSV",
      "exportFullView": "Esporta vista completa in XLSX"
    },
    "search": {
      "placeholder": "Cerca nome"
    },
    "filters": {
      "selectSupplierType": "Seleziona tipo di fornitore",
      "selectStatus": "Seleziona stato",
      "selectRiskType": "Seleziona tipo di rischio",
      "showOnlyArchived": "Mostra solo archiviati"
    },
    "columns": {
      "name": "Nome",
      "type": "Tipo",
      "status": "Stato",
      "risk": "Rischio",
      "sponsor": "Sponsor",
      "lastModified": "Ultima modifica",
      "lastAudit": "Ultimo audit",
      "dueIn": "Scadenza tra"
    },
    "emptyState": {
      "title": "Non hai ancora nessun fornitore",
      "subtitle": "Prima di aggiungere un fornitore, si consiglia di creare una politica dei fornitori. La politica definirà i tipi di fornitore con cui lavori, i livelli di rischio che aiuteranno a valutare i tuoi fornitori e i tipi di documenti richiesti che ogni fornitore deve avere per essere approvato.",
      "buttons": {
        "addSupplier": "Aggiungi fornitore",
        "importSuppliers": "Importa fornitori",
        "configurePolicy": "Configura politica"
      },
      "divider": "o"
    },
    "errors": {
      "noApprovedSuppliers": "Nessun fornitore approvato da esportare",
      "cannotRetrievePolicyLinks": "Impossibile recuperare i link della politica"
    }
  },
  "supplierDetails": {
    "buttons": {
      "back": "Indietro",
      "edit": "Modifica",
      "export": "Esporta",
      "archive": "Archivia",
      "unarchive": "Ripristina",
      "revertToDraft": "Riporta a bozza"
    },
    "tabs": {
      "details": "Dettagli",
      "supportingDocuments": "Documenti di supporto",
      "audits": "Audit"
    },
    "sections": {
      "riskLevel": "Livello di rischio",
      "generalInfo": "Info generali",
      "supplierContactInformation": "Informazioni di contatto del fornitore"
    },
    "fields": {
      "supplierName": "Nome fornitore",
      "supplierType": "Tipo di fornitore",
      "website": "Sito web",
      "intendedUse": "Uso previsto",
      "sponsor": "Sponsor",
      "approvers": "Approvatori",
      "createdOn": "Creato il",
      "lastModified": "Ultima modifica",
      "name": "Nome",
      "email": "Email",
      "phone": "Telefono",
      "address": "Indirizzo",
      "notes": "Note",
      "contactName": "Nome",
      "contactEmail": "Email",
      "contactPhone": "Telefono",
      "contactAddress": "Indirizzo",
      "contactNotes": "Note"
    },
    "modals": {
      "archive": {
        "title": "Archivia",
        "message": "Sei sicuro di voler archiviare questo fornitore? Puoi ripristinarlo in qualsiasi momento.",
        "button": "Archivia"
      },
      "unarchive": {
        "title": "Ripristina",
        "message": "Sei sicuro di voler ripristinare questo fornitore? Lo stato cambierà in \"Bozza\".",
        "button": "Ripristina"
      },
      "revertToDraft": {
        "title": "Riporta a Bozza",
        "message": "Vuoi riportare questo fornitore allo stato \"Bozza\"?",
        "button": "Ripristina"
      },
      "export": {
        "title": "Esporta fornitore",
        "message": "Il fornitore sarà esportato come file zip contenente:\n- Un file PDF con tutti i dettagli del fornitore\n- Documenti di supporto\n- File degli audit",
        "button": "Esporta fornitore"
      }
    }
  },
  "supplierDocuments": {
    "emptyState": {
      "title": "I documenti per questo fornitore appariranno qui",
      "subtitle": "Se la tua politica dei fornitori richiede documenti specifici, modifica il fornitore per includerli qui."
    },
    "heading": "Documenti aggiuntivi"
  },
  "supplierAudits": {
    "columns": {
      "name": "Nome",
      "auditType": "Tipo di audit",
      "notes": "Note",
      "addedBy": "Aggiunto da",
      "dateCompleted": "Data completamento",
      "dateAdded": "Data aggiunta",
      "documents": "Documenti",
      "filesCount": "{{count}} file"
    },
    "menu": {
      "viewDocuments": "Visualizza documenti",
      "edit": "Edit",
      "delete": "Elimina"
    },
    "emptyState": {
      "title": "Gli audit completati appariranno qui",
      "subtitle": "Registra l'esito degli audit precedenti con data di completamento, file correlati e note.",
      "button": "Aggiungi un audit"
    },
    "buttons": {
      "addAudit": "Aggiungi audit"
    },
    "drawer": {
      "noDocuments": "Non ci sono documenti disponibili."
    },
    "modals": {
      "deleteAudit": {
        "title": "Elimina Audit",
        "message": "Sei sicuro di voler eliminare questo audit?",
        "buttons": {
          "cancel": "Annulla",
          "delete": "Elimina audit"
        }
      },
      "addAudit": {
        "title": "Aggiungi audit",
        "buttons": {
          "cancel": "Annulla",
          "add": "Aggiungi audit"
        }
      },
      "editAudit": {
        "title": "Edit audit",
        "buttons": {
          "cancel": "Annulla",
          "save": "Save audit"
        }
      }
    },
    "nextAudit": {
      "dueTemplate": "Il prossimo audit {{auditType}} scade tra {{interval}}",
      "overdueTemplate": "L'audit {{auditType}} è in ritardo di {{interval}}",
      "policyRequires": "La politica dei fornitori richiede che questo fornitore sia sottoposto a un audit {{auditType}} ogni {{frequency}} mese/i dalla data dell'ultimo audit ({{lastAuditDate}})",
      "supplierPolicyLink": "politica dei fornitori"
    }
  },
  "createAuditForm": {
    "heading": "Informazioni audit",
    "fields": {
      "auditName": {
        "label": "Nome audit*",
        "error": "Inserisci il nome dell'audit"
      },
      "auditType": {
        "label": "Tipo di audit*",
        "error": "Inserisci il tipo di audit"
      },
      "notes": {
        "label": "Note"
      },
      "completionDate": {
        "label": "Data completamento",
        "helper": "La data di completamento determina il prossimo audit programmato di questo tipo in base alla politica dei fornitori.",
        "placeholder": "gg/mm/aaaa"
      }
    },
    "sections": {
      "auditDocuments": "Documenti audit"
    },
    "errors": {
      "fillRequiredFields": "Compila i campi obbligatori"
    }
  },
  "documentCard": {
    "buttons": {
      "addDocument": "Aggiungi documento",
      "uploadFromComputer": "Carica dal computer",
      "qualioDoc": "Documento Qualio",
      "download": "Scarica",
      "open": "Apri",
      "delete": "Elimina",
      "addDescription": "Aggiungi descrizione"
    }
  },
  "qualioDocSelect": {
    "noDocumentFound": "Nessun documento trovato con il prefisso:",
    "placeholder": "Inserisci un prefisso valido di un documento Qualio. Es: \"POL\""
  },
  "importModal": {
    "title": "Importa Fornitori",
    "description": "Se conservi i record dei fornitori come documenti Qualio, puoi importarli nell'elenco Fornitori. Inserisci il prefisso del modello dei record dei fornitori",
    "fields": {
      "templatePrefix": {
        "label": "Prefisso modello",
        "helper": "Per esempio \"SQF\"",
        "button": "Cerca"
      }
    },
    "messages": {
      "found": "Sono stati trovati {{count}} record di fornitori con il prefisso {{prefix}}",
      "notFound": "Nessun record di fornitore trovato con il prefisso {{prefix}}"
    },
    "buttons": {
      "cancel": "Annulla",
      "import": "Importa"
    }
  },
  "changeControlAlerts": {
    "approvalDeclined": "Approvazione rifiutata",
    "approvalPreviouslyDeclined": "Approvazione precedentemente rifiutata",
    "declinedMessage": "{{name}} ha rifiutato di approvare questo fornitore il {{date}} per il seguente motivo: \"{{reason}}\""
  },
  "statusChangeModal": {
    "approveTitle": "Approva fornitore",
    "rejectTitle": "Rifiuta fornitore",
    "approveMessage": "Inserisci la tua password per approvare questo fornitore.",
    "rejectMessage": "Inserisci la tua password per rifiutare questo fornitore.",
    "fields": {
      "email": {
        "label": "Email",
        "error": "Inserisci un'email"
      },
      "password": {
        "label": "Password",
        "error": "Inserisci una password"
      },
      "reason": {
        "label": "Motivo del rifiuto",
        "error": "Inserisci un motivo per rifiutare questo fornitore"
      }
    },
    "errors": {
      "fillRequiredFields": "Compila i campi obbligatori",
      "somethingWentWrong": "Qualcosa è andato storto",
      "requiredFields": "Compila i campi obbligatori",
      "generic": "Qualcosa è andato storto",
      "email": "Inserisci un'email",
      "password": "Inserisci una password",
      "reason": "Inserisci un motivo per rifiutare questo fornitore"
    },
    "buttons": {
      "cancel": "Annulla",
      "approve": "Approva",
      "reject": "Rifiuta"
    }
  },
  "policyConfiguration": {
    "heading": "Configurazione Politica",
    "tabs": {
      "supplierTypes": "Tipi di fornitore",
      "riskLevels": "Livelli di rischio",
      "documentTypes": "Tipi di documento",
      "auditTypes": "Tipi di audit"
    },
    "template": {
      "title": "Non hai ancora definito alcun tipo di revisione",
      "subtitle": "Specifica quali tipi di revisione saranno utilizzati nella Politica. Usa il modello suggerito e modificalo per adattarlo alle tue esigenze o creane uno da zero.",
      "useTemplate": "Usa le definizioni {{name}} suggerite",
      "buttons": {
        "useTemplate": "Usa questo modello",
        "createFromScratch": "Crea da zero"
      },
      "divider": "o"
    },
    "configurationCard": {
      "placeholders": {
        "name": "Nome",
        "addDescription": "Aggiungi descrizione"
      }
    },
    "buttons": {
      "addNew": "Aggiungi nuovo",
      "cancel": "Annulla",
      "saveChanges": "Salva modifiche"
    },
    "modals": {
      "saveChanges": {
        "title": "Salva modifiche",
        "message": "Le modifiche apportate ai tipi di fornitore influenzeranno tutti i fornitori esistenti di quei tipi. Assicurati di rivedere tutti i fornitori interessati e di valutarli nuovamente se necessario.",
        "buttons": {
          "cancel": "Annulla",
          "save": "Salva modifiche"
        }
      }
    }
  },
  "supplierPolicy": {
    "heading": "Politica dei Fornitori",
    "buttons": {
      "configuration": "Configurazione",
      "edit": "Modifica",
      "export": "Esporta"
    },
    "tabs": {
      "requiredDocuments": "Documenti richiesti",
      "audits": "Audit"
    },
    "drawer": {
      "title": "Modifica Politica",
      "sections": {
        "supplierType": "Tipo di fornitore",
        "riskLevel": "Livello di rischio",
        "requiredDocuments": "Documenti richiesti",
        "audits": "Audit"
      },
      "descriptions": {
        "requiredDocuments": "La politica richiederà l'aggiunta di questi documenti affinché un fornitore possa essere approvato.",
        "audits": "Questi audit saranno richiesti per tutti i fornitori di questo tipo e livello di rischio."
      },
      "placeholders": {
        "addDocumentType": "Aggiungi tipo di documento",
        "addAuditType": "Aggiungi tipo di audit",
        "dueEvery": "Scade ogni"
      },
      "frequencyOptions": {
        "once": "Una volta",
        "monthsFromLastAudit": "{{count}} mese/i dall'ultimo audit"
      },
      "noTypesFound": "I tipi {{type}} non sono ancora definiti nella tua politica dei fornitori o hai selezionato tutte le opzioni disponibili.",
      "warning": "Le modifiche apportate alla politica dei fornitori influenzeranno tutti i fornitori esistenti di questo tipo e livello di rischio. Rivedi tutti i fornitori interessati e rivalutali se necessario.",
      "buttons": {
        "cancel": "Annulla",
        "save": "Salva"
      }
    },
    "table": {
      "supplierType": "TIPO FORNITORE",
      "riskLevel": "LIVELLO DI RISCHIO"
    }
  },
  "aslExport": {
    "coverPage": {
      "title": "Elenco Fornitori Approvati (ASL)",
      "generatedBy": "Generato da {{userName}}",
      "generatedWith": "Generato con",
      "qmsForLifeSciences": "QMS per Life Sciences",
      "website": "www.qualio.com"
    },
    "listPage": {
      "columns": {
        "supplierName": "Nome fornitore",
        "type": "Tipo",
        "riskLevel": "Livello di rischio",
        "intendedUse": "Uso previsto",
        "lastAudit": "Ultimo audit",
        "auditDue": "Scadenza audit"
      }
    }
  },
  "upSellViews": {
    "upgradeAccess": {
      "title": "Esegui l'upgrade per l'accesso ai Fornitori",
      "subtitle": "Il tuo attuale piano Qualio non include la nuova funzionalità Fornitori. Contatta il tuo referente Customer Success per scoprire come eseguire l'upgrade.",
      "button": "Scopri di più sui Fornitori"
    },
    "insufficientPermissions": {
      "title": "Stai cercando di gestire la supply chain?",
      "subtitle": "Sfortunatamente, al momento non hai accesso al modulo Fornitori. Contatta il tuo amministratore per poter integrare, gestire e migliorare continuamente la tua base di fornitori.",
      "button": "Guarda il video del prodotto"
    },
    "starterView": {
      "title": "Stai cercando di gestire la supply chain?",
      "subtitle": "Sfortunatamente, al momento non hai accesso al modulo Fornitori. Contatta il nostro team di supporto per poter integrare, gestire e migliorare continuamente la tua base di fornitori.",
      "buttons": {
        "contactSupport": "Contatta il supporto Qualio",
        "watchVideo": "Guarda il video del prodotto"
      }
    }
  },
  "emergencyBreak": {
    "title": "Il modulo Fornitori è in manutenzione",
    "subtitle": "Al momento stiamo effettuando lavori di manutenzione su Fornitori. Prendi un caffè e torna tra poco. Contattaci se hai domande."
  },
  "notFound": {
    "message": "Sembri esserti perso"
  },
  "privateRoute": {
    "unauthorizedTitle": "Non hai il permesso di accedere a questo contenuto",
    "unauthorizedSubtitle": "Devi aver effettuato l'accesso come utente Quality per visualizzare e modificare le politiche dei fornitori. Se hai bisogno di accesso, contatta il tuo team quality."
  },
  "navigation": {
    "tabs": {
      "supplier": "Fornitore",
      "policy": "Politica"
    }
  },
  "statuses": {
    "approved": "Approvato",
    "pending": "In attesa",
    "rejected": "Rifiutato",
    "draft": "Bozza",
    "archived": "Archiviato"
  },
  "toastMessages": {
    "supplier": {
      "archived": "Archiviato",
      "archivedDescription": "{{name}} è stato archiviato",
      "archiveFailed": "Fallito",
      "archiveFailedDescription": "Fornitore non archiviato",
      "failure": "Fallito",
      "notArchived": "Fornitore non archiviato",
      "unArchived": "Ripristinato",
      "unArchivedDescription": "{{name}} è stato ripristinato",
      "notUnArchived": "Il fornitore non è stato ripristinato",
      "unarchived": "Ripristinato",
      "unarchivedDescription": "{{name}} è stato ripristinato",
      "unarchiveFailed": "Fallito",
      "unarchiveFailedDescription": "Il fornitore non è stato ripristinato",
      "reverted": "Ripristinato",
      "revertedDescription": "{{name}} è stato riportato a bozza",
      "revertedToDraftDescription": "{{name}} è stato riportato a bozza",
      "notRevertedToDraft": "Il fornitore non è stato riportato a bozza",
      "revertFailed": "Fallito",
      "revertFailedDescription": "Il fornitore non è stato riportato a bozza",
      "saved": "Salvato",
      "savedAsDraft": "{{name}} è stato salvato come bozza.",
      "savedAsDraftDescription": "{{name}} è stato salvato come bozza.",
      "notSavedAsDraft": "Il fornitore non è stato salvato come bozza",
      "notSentForApproval": "Il fornitore non è stato inviato per l'approvazione",
      "sent": "Inviato",
      "sentForApproval": "{{name}} è stato inviato per l'approvazione",
      "sentForApprovalDescription": "{{name}} è stato inviato per l'approvazione",
      "saveFailed": "Fallito",
      "saveFailedDescription": "Il fornitore non è stato salvato come bozza.",
      "fileReady": "File Pronto",
      "fileReadyDescription": "Il file è ora disponibile per il",
      "download": "download",
      "exportFailed": "Fallito",
      "exportFailedDescription": "Fornitore non esportato",
      "notExported": "Fornitore non esportato",
      "revertedToDraft": "{{name}} è stato riportato a bozza",
      "revertToDraftFailed": "Fornitore non riportato a bozza",
      "preparingFile": "Preparazione del file per il download",
      "preparingFileDescription": "Ti informeremo quando il file sarà pronto",
      "exportsFailed": "Fornitori non esportati",
      "suppliersNotExported": "Fornitori non esportati"
    },
    "audit": {
      "added": "Audit aggiunto",
      "creationFailed": "Creazione audit fallita",
      "creationFailedDescription": "Impossibile allegare l'audit al fornitore",
      "updated": "Audit updated",
      "updateFailed": "Audit update failed",
      "updateFailedDescription": "Failed to update the audit",
      "deleted": "Audit eliminato",
      "deletionFailed": "Eliminazione audit fallita",
      "deletionFailedDescription": "Impossibile eliminare l'audit dal fornitore"
    },
    "config": {
      "configuration": "Configurazione",
      "updated": "{{configType}} è stato aggiornato",
      "updateFailed": "Aggiornamento configurazione fallito"
    },
    "policy": {
      "saved": "Politica salvata",
      "savedDescription": "Potrebbe essere necessario rivalutare i fornitori interessati.",
      "saveFailed": "Fallito",
      "saveFailedDescription": "Impossibile salvare la politica."
    },
    "policyLinks": {
      "fetchFailed": "Si è verificato un errore nel recupero dei documenti di supporto richiesti"
    },
    "import": {
      "success": "Importazione riuscita",
      "successDescription": "I fornitori sono stati importati con successo",
      "failed": "Importazione fallita",
      "failedDescription": "Impossibile importare i fornitori"
    },
    "approval": {
      "completed": "Azione di approvazione completata"
    },
    "document": {
      "downloadError": "Errore",
      "downloadErrorDescription": "Si è verificato un errore scaricando questo documento"
    },
    "export": {
      "error": "Errore",
      "errorDescription": "Nessun fornitore approvato da esportare",
      "policyLinksError": "Impossibile recuperare i link della politica",
      "supplierExportToast": "Esportazione {{name}}",
      "configExportToast": "Esportazione configurazione fornitore"
    }
  },
  "common": {
    "buttons": {
      "cancel": "Annulla",
      "save": "Salva",
      "delete": "Elimina",
      "edit": "Modifica",
      "close": "Chiudi",
      "review": "Rivedi",
      "ok": "Ok",
      "gotIt": "Ricevuto"
    },
    "placeholders": {
      "noData": "--"
    },
    "ariaLabels": {
      "deleteDescription": "elimina-descrizione",
      "downloadFile": "Scarica file",
      "openQualioDoc": "Apri documento Qualio",
      "deleteFile": "Elimina file",
      "deletePolicyRow": "Elimina riga politica",
      "viewRelatedRecords": "Visualizza record correlati"
    },
    "misc": {
      "auditType": "Tipo di audit:",
      "name": "Nome:",
      "type": "Tipo:"
    }
  }
}
